import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'core/libs/router';
import { ancestryAttributes } from 'core/utils/prop-types/model';
import styles from './index.styl';

function RubricSelect(props) {
  const {
    rubrics: {
      meta: {
        ancestry: [
          {
            rubric: tagsRoot,
            children: tagsChildren,
          },
        ],
      },
    },
    match: {
      params: {
        level_1: level1,
        level_2: level2,
      },
    },
  } = props;

  if (!tagsChildren.length) return null;

  const handleChange = (e) => {
    props.history.push(e.target.value);
  };

  const tags = [].concat(tagsRoot, tagsChildren).filter(item => item.attributes.enabled);
  tags.sort((a, b) => {
    const aRootEqualsSlug = a.attributes.root_slug === a.attributes.slug;
    const bRootEqualsSlug = b.attributes.root_slug === b.attributes.slug;

    if (aRootEqualsSlug && !bRootEqualsSlug) {
      return -1;
    }
    if (!aRootEqualsSlug && bRootEqualsSlug) {
      return 1;
    }
    const titleA = a.attributes.title.toUpperCase();
    const titleB = b.attributes.title.toUpperCase();
    if (titleA < titleB) {
      return -1;
    }
    if (titleA > titleB) {
      return 1;
    }
    return 0;
  });
  return (
    <div className={styles.selectWrapper}>
      <select onChange={handleChange} className={styles.select}>
        {tags.map(({
          id,
          attributes: {
            slug,
            root_slug: rootSlug,
            title: tagTitle,
          },
        }) => {
          const isActive = (!level2 && level1 === slug) || level2 === slug;
          const link = rootSlug === slug ? `/${level1}` : `/${level1}/${slug}`;
          const name = rootSlug === slug ? 'Все' : tagTitle;

          return (
            <option
              key={id}
              value={link}
              selected={isActive}
            >
              {name}
            </option>
          );
        })}
      </select>
    </div>
  );
}

RubricSelect.propTypes = {
  rubrics: PropTypes.shape({
    meta: PropTypes.shape({
      ancestry: ancestryAttributes,
    }),
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      level_1: PropTypes.string.isRequired,
      level_2: PropTypes.string,
    }).isRequired,
  }).isRequired,
  /** @ignore */
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const RubricSelectWithHOCs = withRouter(RubricSelect);
RubricSelectWithHOCs.displayName = 'RubricSelect';

export { RubricSelect as StorybookComponent };
export default RubricSelectWithHOCs;
